import {Box, CircularProgress } from "@mui/material";
import React from "react";


export const styles = {
    loading: {
        inset: 0,
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        pointerEvents:'none'
    },
    loadingRight: {
        position: "relative",
        top: 10,
        left: 8,
    }
};



const LoadingProgress = (props: any) => {


    return (
        <React.Fragment>
            <Box sx={[styles.loading]}>
                <CircularProgress color="primary" />
            </Box>
        </React.Fragment>
    )
}

const LoadingRight = (props: any) => {

    return (
        <CircularProgress size={28} sx={[styles.loadingRight]}/>
    )
}


export {LoadingProgress, LoadingRight };
